import React, { useState, useEffect } from "react";
import { useUser } from "../../context/UserContext";
import axios from "axios";
import jsPDF from "jspdf";
import {
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Box,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { API_BASE_URL } from "../dashboardContent/config";
import { getFirstBaccalaureateOptions } from "../../constants/firstBaccalaureateOptions";
import { useLocation } from "react-router-dom";
import "../../StylesCSS/EtudiantsInterieurVille.css";
import BranchLabelBanner from './BranchLabelBanner';

const GradeScale = ({ setActiveSection }) => {
  const location = useLocation();
  const { branchLabel } = location.state || {};
  const firstBaccalaureateOptions = getFirstBaccalaureateOptions(branchLabel);

  // Variables internes
  const { userId } = useUser();
  const [institutions, setInstitutions] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState("");
  const [selectedVille, setSelectedVille] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [directorNotes, setDirectorNotes] = useState("");
  const [guidanceNotes, setGuidanceNotes] = useState("");

  const [seuil, setSeuil] = useState('');

   // Récupérer le seuil existant à la première connexion
   useEffect(() => {
    const fetchSeuil = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/version2/api/seuil/${userId}`);
        if (response.data && response.data.seuil !== null) {
                    setSeuil(response.data.seuil); // Mettre à jour l'état avec la valeur du seuil

        }
        else{
          setSeuil(''); // Réinitialiser le seuil si aucun seuil n'existe
        }
      } catch (error) {
        
        console.error('Erreur lors de la récupération du seuil:', error);
      }
    };

    fetchSeuil();
  }, [userId]);
  

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/version2/api/excel/institutions/${userId}`, {
        params: {
          branchLabel: branchLabel || '',
        },
      })
      .then((response) => setInstitutions(response.data))
      .catch((error) =>
        console.error("Erreur lors de la récupération des institutions:", error)
      );
  }, [userId, branchLabel]);

  const handleGoBack = (section) => {
    setActiveSection(section);
    console.log("Retour");
  };

  const getDistributionStudentsCommonCores = async (selectedInstitution) => {
      const response = await fetch(`${API_BASE_URL}/version2/api/students/DistributionStudentsCommonCores?selectedInstitution=${encodeURIComponent(selectedInstitution)}&userId=${userId}&branchLabel=${encodeURIComponent(branchLabel || "")}`);
   
    const data = await response.json();
    return data; // retourne un objet { filles: x, garcons: y }
  };

  /* const generateFinalResults = async (selectedInstitution) => {
    const response = await fetch(
      `${API_BASE_URL}/version2/api/students/countResultByScore?selectedInstitution=${selectedInstitution}`
    );
    const data = await response.json();
    return data; // retourne un objet { filles: x, garcons: y }
  }; */
  const generateFinalResults = async (selectedInstitution) => {
  const response = await fetch(
    `${API_BASE_URL}/version2/api/students/countResultByScore?selectedInstitution=${encodeURIComponent(selectedInstitution)}&userId=${userId}&branchLabel=${encodeURIComponent(branchLabel || "")}`
  );
  const data = await response.json();
  return Array.isArray(data)
    ? data.filter((item) => item.name === "المجموع العام"
      || firstBaccalaureateOptions.includes(item.name))
    : [];
};


  const generateFinalResults1 = async (selectedInstitution) => {
    const response = await fetch(`${API_BASE_URL}/version2/api/students/countResultGradeScale?selectedInstitution=${encodeURIComponent(selectedInstitution)}&userId=${userId}&branchLabel=${encodeURIComponent(branchLabel || "")}`);
    const data = await response.json();
    return data; // retourne un objet { filles: x, garcons: y }
  };

  console.log("institution ->", selectedInstitution);
  console.log("selectedVille", selectedVille);
  console.log("selectedDate", selectedDate);

    const [directions, setDirections] = useState({ direction_provinciale: '', direction_regionale: '' });
  const [loading, setLoading] = useState(true);


   useEffect(() => {
    if (userId) {
      axios.get(`${API_BASE_URL}/api/forms/directions/${userId}`)
        .then(response => {
          console.log('Direction provinciale :', response.data.direction_provinciale);
          console.log('Direction régionale :', response.data.direction_regionale);
          setDirections(response.data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Erreur lors du chargement des directions:', error);
          setLoading(false);
        });
    }
  }, [userId]);


  const handleExportPDF = async () => {
    const data = await getDistributionStudentsCommonCores(selectedInstitution);
    const data2 = await generateFinalResults(selectedInstitution);
    const data3 = await generateFinalResults1(selectedInstitution);

    console.log("data new version 2",data2);
    console.table(data2);


    data2.forEach((item, index) => {
        console.log(`Filière ${index + 1}:`, item.name);
        item.sexList.forEach((stat) => {
          console.log(`  Genre: ${stat.gender}`);
          console.log(`    < 8: ${stat.lessThan8}`);
          console.log(`    8 - 9: ${stat.between8and9}`);
          console.log(`    9 - 10: ${stat.between9and10}`);
          console.log(`    10 - 11: ${stat.between10and11}`);
        });
      });
      

    if (!data) {
      console.error("Data not received from API");
      return;
    }
    const doc = new jsPDF();
    // Ajouter les polices
    doc.addFileToVFS(
      "NotoSansArabic-Regular2.ttf",
      "/fonts/NotoSansArabic-Regular2.ttf"
    );
    doc.addFont(
      "/fonts/NotoSansArabic-Regular2.ttf",
      "NotoSansArabic",
      "normal"
    );
    doc.setFont("NotoSansArabic");
    doc.setFontSize(12);

    const img = new Image();
    img.src = "/images/Photo1.PNG";
    await new Promise((resolve) => {
      img.onload = resolve;
    });

    const imgWidth = 80;
    const imgHeight = (img.height * imgWidth) / img.width;
    doc.addImage(
      img,
      "PNG",
      (doc.internal.pageSize.width - imgWidth) / 2,
      10,
      imgWidth,
      imgHeight
    );

    doc.setFont("NotoSansArabic");

    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0); // Couleur noire pour les trois premières lignes

    // Ajouter les trois premiers textes avec les nouvelles propriétés
    doc.text(
  `الأكاديمية الجهوية : ${directions.direction_regionale}`, 
  doc.internal.pageSize.width / 2, 
  imgHeight + 15, 
  { align: 'center' }
);

doc.text(
  `مديرية ${directions.direction_provinciale}`, 
  doc.internal.pageSize.width / 2, 
  imgHeight + 30, 
  { align: 'center' }
);
    doc.text(
      "  مصلحة تأطير المؤسسات التعليمية و التوجيه  ",
      doc.internal.pageSize.width / 2,
      imgHeight + 25,
      { align: "center" }
    );

    // Ajouter le titre principal
    const pageWidth = doc.internal.pageSize.width;

    // Information de l'institution
    doc.text(
      "المؤسسة : " + selectedInstitution,
      pageWidth - 20,
      imgHeight + 35,
      { align: "right" }
    );

    
    doc.setFont('NotoSansArabic');
    doc.text("تاريخ انعقاد المجلس : " + selectedDate, pageWidth -180, imgHeight + 35, { align: 'left' });

    doc.setFontSize(13);

    doc.text(`مدراج النقط بالنسبة لتلاميذ : ${branchLabel || ""}`, pageWidth / 2, imgHeight + 45, {
      align: "center",
    });
    const gradeScaleTitle = `مدراج النقط بالنسبة لتلاميذ : ${branchLabel || ""}`;
    const gradeScaleTitleWidth = doc.getTextWidth(gradeScaleTitle);
    doc.line(
      pageWidth / 2 - gradeScaleTitleWidth / 2,
      imgHeight + 47,
      pageWidth / 2 + gradeScaleTitleWidth / 2,
      imgHeight + 47
    );

    doc.setFontSize(11);

    doc.text(
"-  توزيع تلاميذ الموجهين حسب امكانات التوجيه المتاحة ومعدلاتهم العامة السنوية - الأولى بكالوريا",        
        pageWidth / 2,
        imgHeight + 55,
        { align: "center" }
      );
  

    doc.setFontSize(11);
    console.log("data2 --->>", data2);


    
    const body2 = [];
    data3.forEach((genderInfo, index) => {
        console.log("genderInfo",genderInfo);
        body2.push([
            // Colonne "العتبة" - fusion verticale
            index === 0 ?  { 
                content: seuil, 
                rowSpan: 1,
                styles: { valign: "middle", halign: "center" } 
            } : "" ,
            
            // Colonne "المفصولون"
            { content: genderInfo.countYofsal, styles: { halign: "center" } },
            
            // Colonne "المكررون"
            { content: genderInfo.countYokarrer, styles: { halign: "center" } },
            
            // Colonne "الجنس"
            { content: genderInfo.name, styles: { halign: "center" } },
            
            // Colonne "الوسط" - fusion verticale
            index === 0 ? { content: "حضري",  rowSpan: data3.length, styles: { valign: "middle", halign: "center" }  } : ""

            
        ]);
    });


    // Structure de la table avec les nouvelles en-têtes imbriquées
    doc.autoTable({
      startY: imgHeight + 60,
      head: [
        [
          { content: "العتبة", colSpan: 1 },
          { content: "المفصولون", colSpan: 1 },
          { content: "المكررون", colSpan: 1 },
          { content: "الجنس", colSpan: 1 },
          { content: "الوسط ", colSpan: 1 },
        ]
      ],
      body: body2,
      theme: "grid",
      styles: { font: "NotoSansArabic", fontSize: 8, halign: "right" },
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 28.3 },
        1: { cellWidth: 35 },
        2: { cellWidth: 35 },
        3: { cellWidth: 45 },
        4: { cellWidth: 50 },
       
      },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.5,
      margin: { top: 10, right: 6, bottom: 10, left: 10 },
    });
    doc.setFontSize(12);
  
    
    const bodyRows = [];


    data2.forEach((filiere) => {
      filiere.sexList.forEach((stat, index) => {
        const total =
          stat.lessThan8 +
          stat.between8and9 +
          stat.between9and10 +
          stat.between10and12 +
          stat.between12and14 +
          stat.between14and16 +
          stat.between16and20;
    
        const row = [
          { content: total, styles: { halign: 'center' } },
          { content: stat.between16and20, styles: { halign: 'center' } },
          { content: stat.between14and16, styles: { halign: 'center' } },
          { content: stat.between12and14, styles: { halign: 'center' } },
          { content: stat.between10and12, styles: { halign: 'center' } },
          { content: stat.between9and10, styles: { halign: 'center' } },
          { content: stat.between8and9, styles: { halign: 'center' } },
          { content: stat.lessThan8, styles: { halign: 'center' } },
          { content: stat.gender, styles: { halign: 'center' } },
        ];
    
        // Pour la première ligne (par exemple "homme"), on ajoute la filière avec rowspan = 2
        if (index === 0) {
          row.push({
            content: filiere.name,
            rowSpan: 2,
            styles: { halign: 'center', valign: 'middle' }
          });
        }
    
        // Si c'est "المجموع العام", on applique une mise en forme spéciale et on évite les doublons
        if (filiere.name === "المجموع العام") {
          row.forEach(cell => {
            cell.styles.fontStyle = 'bold';
          });
    
          // Éviter d'ajouter "المجموع العام" plus d'une fois
          if (bodyRows.length > 0 && bodyRows[bodyRows.length - 1][0].content === "المجموع العام") {
            return; // Ne pas ajouter une nouvelle ligne pour "المجموع العام"
          }
        }
    
        bodyRows.push(row);
      });
    });
    

    // Utilisation de `autoTable` pour générer le tableau
    doc.autoTable({
      startY: imgHeight + 88, // Ajustez la position Y en fonction du reste du document
      head: [
        [
          { content: 'المجموع', styles: { halign: 'center' }, rowSpan: 2 },
          { content: 'مجالات المعدلات السنوية العامة', styles: { halign: 'center' }, colSpan: 7 },
          { content: 'الجنس', styles: { halign: 'center' }, rowSpan: 2 },
          { content: 'امكانات التوجيه المتاحة', styles: { halign: 'center' }, rowSpan: 2 }
        ],
        [
            { content: ']20 - 16]', styles: { halign: 'center', font: 'NotoSans' } },
            { content: ']16 - 14]', styles: { halign: 'center', font: 'NotoSans' } },
            { content: ']14 - 12]', styles: { halign: 'center', font: 'NotoSans' } },
            { content: ']12 - 10]', styles: { halign: 'center', font: 'NotoSans' } },
            { content: ']10 - 9]', styles: { halign: 'center', font: 'NotoSans' } },
            { content: ']9 - 8]', styles: { halign: 'center', font: 'NotoSans' } },
          { content: 'أقل من 8', styles: { halign: 'center' } }
        ],
      
      ],
      body: bodyRows,
      theme: "grid",
      styles: { font: "NotoSansArabic", fontSize: 9 },
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 15 },  // المجموع
        1: { cellWidth: 18 },  // ]20 - 16]
        2: { cellWidth: 18 },  // ]16 - 14]
        3: { cellWidth: 18 },  // ]14 - 12]
        4: { cellWidth: 18 },  // ]12 - 10]
        5: { cellWidth: 18 },  // ]10 - 9]
        6: { cellWidth: 18 },  // ]9 - 8]
        7: { cellWidth: 20 },  // أقل من 8
        8: { cellWidth: 17 },  // الجنس
        9: { cellWidth: 35 }   // امكانات التوجيه المتاحة
      },
      
      tableWidth: 195,
      margin: { right: 5, left: 10 },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.1,
    });
    doc.setFontSize(10);
    const notesTableData = [
      ["ملاحظات وتوقيع رئيس المؤسسة"], // Ligne des titres
      [directorNotes, guidanceNotes], // Ligne vide pour les signatures
    ];
    const tableWidth = 100; // largeur totale du tableau (tu peux ajuster)
    const rightMargin = 10; // marge droite désirée

// Calculer la marge gauche pour aligner le tableau à droite
const marginLeft = pageWidth - tableWidth - rightMargin;
    // Options pour centrer le tableau au bas de la page
    doc.autoTable({
      head: [notesTableData[0]], // En-tête du tableau
      body: [notesTableData[1]], // Contenu du tableau (lignes vides)
      startY: doc.internal.pageSize.height - 50, // Positionner le tableau en bas de la page
      styles: {
        font: "NotoSansArabic", // Police arabe
        fontSize: 10,
        halign: "center", // Centrer horizontalement
        cellPadding: 5, // Espacement dans les cellules
      },
      theme: "grid", // Bordures du tableau
      headStyles: {
        fillColor: [240, 240, 240], // Couleur de fond des en-têtes
        textColor: [0, 0, 0], // Couleur du texte des en-têtes
      },
      columnStyles: {
        0: { cellWidth: (pageWidth - 20) / 2, halign: "center" },
        1: { cellWidth: (pageWidth - 20) / 2, halign: "center" },
      },
      margin: { left: marginLeft }
    });

    // Enregistrer le document

    doc.save("مدراج_النقط.pdf");
  };

  return (
    <>
      <Box
        component="form"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          const requiredFieldIds = ["institution", "meeting-date"];
          const firstEmptyField = requiredFieldIds
            .map((fieldId) => event.currentTarget.elements.namedItem(fieldId))
            .find((field) => field && !field.value);

          if (firstEmptyField) {
            firstEmptyField.reportValidity();
            return;
          }

          handleExportPDF();
        }}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          padding: "2rem",
          backgroundColor: "#f4f6f8", // Couleur de fond douce
          borderRadius: "10px",
          border: "1px solid #dcdcdc",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          maxWidth: "700px",
          margin: "auto",
          textAlign: "right",
        }}
      >
        <BranchLabelBanner branchLabel={branchLabel} style={{ width: '100%', maxWidth: 'none' }} />
        <Typography
          variant="h5"
          sx={{
            marginBottom: "1rem",
            fontWeight: "500",
            color: "#2c3e50",
            textAlign: "center",
          }}
        >
          مدراج النقط بالنسبة لتلاميذ : {branchLabel || ""}
        </Typography>

        <FormControl
          className="rtl-field"
          fullWidth
          variant="outlined"
          sx={{ marginBottom: "1.5rem" }}
        >
          <InputLabel
            sx={{
              textAlign: "right",
              fontSize: "1.1rem",
              marginBottom: "0.5rem",
              color: "#2c3e50",
            }}
          >
            اختر المؤسسة
          </InputLabel>
          <Select
            id="institution"
            name="institution"
            required
            value={selectedInstitution}
            onChange={(e) => setSelectedInstitution(e.target.value)}
            label="اختر المؤسسة"
            sx={{
              textAlign: "right",
              direction: "rtl",
              backgroundColor: "#ffffff",
              "&:hover": {
                backgroundColor: "#f1f1f1",
              },
              "&:focus": {
                borderColor: "#2980b9", // Bleu plus clair lors du focus
              },
            }}
          >
            {institutions.map((institution) => (
              <MenuItem
                key={institution}
                value={institution}
                style={{ textAlign: "right" }}
              >
                {institution}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          id="meeting-date"
          className="rtl-field"
          label="تاريخ انعقاد المجلس"
          type="date"
          required
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          sx={{ marginBottom: "1rem", textAlign: "right", direction: "rtl" }}
        />

        {/* Textarea pour ملاحظات وتوقيع رئيس المؤسسة */}
        <TextField
          fullWidth
          className="rtl-field"
          label="ملاحظات وتوقيع رئيس المؤسسة"
          multiline
          rows={4}
          value={directorNotes}
          onChange={(e) => setDirectorNotes(e.target.value)}
          sx={{ marginBottom: "1rem", textAlign: "right", direction: "rtl" }}
        />

        {/* Boutons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "1rem",
          }}
        >
          <Button
            type="button"
            variant="outlined"
            onClick={() => handleGoBack("PageLayout3V2")}
            sx={{
              borderRadius: "8px",
              borderColor: "#e74c3c",
              backgroundColor: "#e74c3c",
              color: "#ffffff",
              padding: "8px 16px", // Ajustez les marges internes
              fontSize: "14px", // Ajustez la taille du texte
              "&:hover": {
                backgroundColor: "#c0392b",
              },
            }}
            startIcon={<ArrowBackIcon />} // Ajoute l'icône au début du texte
          >
            رجوع
          </Button>
          <div className="form-group" style={{ textAlign: "center" }}>
            <button
              type="submit"
              className="btn btn-secondary"
              style={{ backgroundColor: "#087f83", color: "#ffffff" }}
            >
              PDF تصدير إلى
            </button>
          </div>
        </Box>
      </Box>
    </>
  );
};
export default GradeScale;
